import { render, staticRenderFns } from "./StepperComponent.vue?vue&type=template&id=3673b4dc&scoped=true&"
import script from "./StepperComponent.vue?vue&type=script&lang=js&"
export * from "./StepperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673b4dc",
  null
  
)

export default component.exports